export { default } from './Tooltip';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Tooltip/index.js
// module id = 603
// module chunks = 121